import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetSurveyQuestionViewsRPC } from "./getSurveyQuestionViewsRPC";

export class GetSurveyQuestionViewsRPCClientImpl extends GetSurveyQuestionViewsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetSurveyQuestionViewsRPC.Request): Promise<LeoRPCResult<GetSurveyQuestionViewsRPC.Response, GetSurveyQuestionViewsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/GetSurveyQuestionViews",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetSurveyQuestionViewsRPC.ResponseDTO,
      GetSurveyQuestionViewsRPC.Errors.ErrorsDTO,
      GetSurveyQuestionViewsRPC.Response,
      GetSurveyQuestionViewsRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/GetSurveyQuestionViews",
      GetSurveyQuestionViewsRPC.Response.fromDTO,
      GetSurveyQuestionViewsRPC.Errors.fromDTO
    );
  }
}
